<template>
  <div class="final-cta-section">
    <ScalingBackground
      class="final-cta-section__background"
      :largeWidth="backgroundLargeWidth"
      :largeHeight="backgroundLargeHeight"
      :smallWidth="backgroundSmallWidth"
      :smallHeight="backgroundSmallHeight"
    />
    <div class="section__content-wrapper">
      <div class="final-cta-section__center">
        <h2 class="final-cta-section__title" v-html="headline">
        </h2>
        <p class="final-cta-section__copy" v-html="bodyCopy">
        </p>
        <solid-button
          buttonIcon="chevron_right"
          :to="{name: 'entryForm'}"
          @click.capture.native="handleEnterClick"
          v-if="contestActive">
          {{buttonCopy}}
        </solid-button>
        <RulesDisplay
          class="final-cta-section__rules-display"
          :large="!mediaSmall" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {
  CONTENT_FINAL_CTA_SECTION_BODY,
  CONTENT_FINAL_CTA_SECTION_HEADLINE,
  CONTENT_GENERAL_ENTER_CTA,
  SIZE_WIDTH_FINAL_CTA_SECTION_SMOKE_LARGE,
  SIZE_WIDTH_FINAL_CTA_SECTION_SMOKE_SMALL,
  SIZE_HEIGHT_FINAL_CTA_SECTION_SMOKE_LARGE,
  SIZE_HEIGHT_FINAL_CTA_SECTION_SMOKE_SMALL
} from '../../design-tokens/build/dictionary';
import RulesDisplay from './../components/rules-display';

import { getNumberFromToken } from '../core/utils';
import ScalingBackground from './../components/scaling-background';
import tracking from '../core/tracking';

export default {
  name: 'final-cta-section',
  components: {
    ScalingBackground,
    RulesDisplay,
  },
  data() {
    return {
      headline: CONTENT_FINAL_CTA_SECTION_HEADLINE,
      bodyCopy: CONTENT_FINAL_CTA_SECTION_BODY,
      buttonCopy: CONTENT_GENERAL_ENTER_CTA
    };
  },
  computed: {
    backgroundLargeWidth() {
      return getNumberFromToken(SIZE_WIDTH_FINAL_CTA_SECTION_SMOKE_LARGE);
    },
    backgroundSmallWidth() {
      return getNumberFromToken(SIZE_WIDTH_FINAL_CTA_SECTION_SMOKE_SMALL);
    },
    backgroundLargeHeight() {
      return getNumberFromToken(SIZE_HEIGHT_FINAL_CTA_SECTION_SMOKE_LARGE);
    },
    backgroundSmallHeight() {
      return getNumberFromToken(SIZE_HEIGHT_FINAL_CTA_SECTION_SMOKE_SMALL);
    },
    ...mapState('windowMedia', ['mediaSmall']),
    ...mapGetters('ui', ['contestActive']),
  },
  methods: {
    handleEnterClick() {
      tracking.trackEvent('e-rb-cta-1');
    }
  }
};
</script>

<style lang="scss">

$final-cta-section-ideal-ratio:
  $size-height-final-cta-section-large / $size-width-final-cta-section-large;
$final-cta-section-ideal-ratio-small:
  $size-height-final-cta-section-small / $size-width-final-cta-section-small;


.final-cta-section {
  text-align: center;
  min-height: $final-cta-section-ideal-ratio * $size-width-grid-full-medium;
  padding: $size-padding-top-final-cta-section-large 0 $size-padding-bottom-final-cta-section-large;
  margin: $size-margin-top-final-cta-section-large 0 $size-margin-bottom-final-cta-section-large;

  @include global-media(small) {
    min-height: $final-cta-section-ideal-ratio-small * $size-width-grid-full-small;
    padding: $size-padding-top-final-cta-section-small 0 $size-padding-bottom-final-cta-section-small;
    margin: $size-margin-top-final-cta-section-small 0 $size-margin-bottom-final-cta-section-small;
  }
  .section__content-wrapper {
    height: 100%;
  }
  z-index: $z-index-section-with-bkg;
  &__title {
    @include heading-2;
    @include grid-block($columns: 6, $medium-columns: 8);
    margin: auto;
  }
  &__copy {
     @include body-copy-small;
     @include grid-block($columns: 8, $medium-columns: 8);
     margin:
      $size-margin-top-final-cta-section-copy-base
      auto
      $size-margin-bottom-final-cta-section-copy-base;
  }
  &__rules-display {
    margin: $size-margin-top-final-cta-section-disclaimer-large auto 0;
    max-width: $size-max-width-final-cta-section-disclaimer-large;
    @include global-media(small) {
      margin: $size-margin-top-final-cta-section-disclaimer-small auto 0;
    }
  }
}
</style>
